module.exports = __webpack_public_path__ + "overview-a5b6df21/error-a5fd004a6bafb6dd2b3e03b62f126df3.svg";